import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  /**
   * used to open or close the menu
   */
  readonly onMenuStateChange = new EventEmitter<boolean>();
  private state = false; // false if closed, true if open

  open() {
    this.state = true;
    this.onMenuStateChange.emit(this.state);
  }

  close() {
    this.state = false;
    this.onMenuStateChange.emit(this.state);
  }

  currentState() {
    return this.state;
  }
}
